import { api } from "./client";

export interface EmergencyState {
  contractVersion: string;
  appMode: string;
  appEnabled: boolean;
  maintenanceMessage: string | null;
  minimumVersion: string;
  minimumVersionCode: number;
  forceUpdate: boolean;
  configRevision: number;
  updatedAt: string;
}

export interface PublicHealth {
  status: string;
  updatedAt: string;
}

/**
 * docs/API_CONTRACT.md - GET /api/public/v1/emergency-state
 * Used on the dashboard to show IESAPP's own view of its state, independent
 * from the admin-editable config, as a sanity check that publication worked.
 */
export function getEmergencyState(): Promise<EmergencyState> {
  return api.get<EmergencyState>("/public/v1/emergency-state");
}

/** docs/API_CONTRACT.md - GET /api/public/v1/health */
export function getPublicHealth(): Promise<PublicHealth> {
  return api.get<PublicHealth>("/public/v1/health");
}
